import * as yup from 'yup'

export const productionUnitSchema = yup.object().shape({
  AssetCompanyID: yup.number().required('Asset Company ID is required'),
  AssetID: yup.string().required('Asset ID is required'),
  FiscalYear: yup.number().required('Fiscal Year is required').min(1900, 'Invalid year'),
  FiscalPeriod: yup
    .number()
    .required('Fiscal Period is required')
    .min(1, 'Invalid period')
    .max(12, 'Invalid period'),
  PeriodEndDate: yup.string().required('Period End Date is required'),
  UnitsProduced: yup
    .number()
    .required('Units Produced is required')
    .min(0, 'Units Produced must be positive')
    .max(2147483647, 'Units Produced must be less than 2,147,483,647'),
})
